export const app_yes_no_en = {
  true: 'Yes',
  false: 'No',
};
